import { array } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';
import type { TimeframeType } from 'webapp/enums/enums';

import joinClasses from 'webapp/helpers/join-classes';
import CommonTimeframePopupComponent from 'webapp/components/common/timeframe/popup';
import CommonTimeframePopupItemComponent from 'webapp/components/common/timeframe/popup/item';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class GoalsTimeframePopupIndexComponent extends CommonTimeframePopupComponent {
	override get popupData() {
		return this.args.model.data as PopupData.Goal.Timeframe;
	}

	get isContinuousDisabled() {
		return !!this.popupData.isContinuousDisabled;
	}

	get continuousDisabledTooltip() {
		return this.popupData.continuousDisabledTooltip ?? '';
	}

	@action
	override changeSelected(type: TimeframeType | null, year: number) {
		super.changeSelected(type, year);

		this.apply();
	}
	<template>
		<div class="context-ct">

			<a
				role="button"
				class={{joinClasses (array "nav-arrow" (if this.isPrevArrowDisabled "disabled"))}}
				{{on "click" this.goPrev}}
			>
				<CommonUiIconComponent @name="ChevronLeft" @size="sm" />
			</a>

			<div class="items-wrapper">
				<div class="row">
					<CommonTimeframePopupItemComponent
						@type={{this.typeYear}}
						@year={{this.currentYear}}
						@dateLabel={{this.yearDateLabel}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isYearDisabled}}
					/>
				</div>
				<div class="row">
					<CommonTimeframePopupItemComponent
						@type={{this.typeH1}}
						@year={{this.currentYear}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isH1Disabled}}
					/>
					<CommonTimeframePopupItemComponent
						@type={{this.typeH2}}
						@year={{this.currentYear}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isH2Disabled}}
					/>
				</div>
				<div class="row">
					<CommonTimeframePopupItemComponent
						@type={{this.typeQ1}}
						@year={{this.currentYear}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isQ1Disabled}}
					/>
					<CommonTimeframePopupItemComponent
						@type={{this.typeQ2}}
						@year={{this.currentYear}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isQ2Disabled}}
					/>
					<CommonTimeframePopupItemComponent
						@type={{this.typeQ3}}
						@year={{this.currentYear}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isQ3Disabled}}
					/>
					<CommonTimeframePopupItemComponent
						@type={{this.typeQ4}}
						@year={{this.currentYear}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isQ4Disabled}}
					/>
				</div>
				<div class="row">
					<CommonTimeframePopupItemComponent
						@type={{null}}
						@year={{this.currentYear}}
						@selected={{this.selected}}
						@onChange={{this.changeSelected}}
						@isDisabled={{this.isContinuousDisabled}}
						@tooltipText={{this.continuousDisabledTooltip}}
					/>
				</div>
			</div>

			<a role="button" class="nav-arrow" {{on "click" this.goNext}}>
				<CommonUiIconComponent @name="ChevronRight" @size="sm" />
			</a>

		</div>

		{{#if this.popupData.onClear}}
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Show all timeframes"
						@theme="grey-empty"
						@size="small"
						@noDelay={{true}}
						@onTrigger={{this.clear}}
					/>
				</div>
			</div>
		{{/if}}
	</template>
}
